export default __webpack_public_path__ + "5f4146fd9debd7ad194034821bb638e6.svg";